import { config } from "config";
import * as React from "react";
import { useSelector } from "react-redux";

import { OpenInNew } from "@livechat/design-system-icons";
import { Button, Icon, SpacingToken } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import Flex from "components/layout/Flex";
import { getPrivateApplications } from "store/entities/applications";
import { withVar } from "themes/helpers";

import ApplicationItem from "../../components/ApplicationItem";
import EmptyState from "../../components/EmptyState";

const PrivateApps: React.FC = () => {
  const applications = useSelector(getPrivateApplications);

  if (!applications?.length) {
    return <EmptyState />;
  }

  return (
    <Flex column gap={withVar(SpacingToken.Spacing3)} marginBottom="60px">
      {applications?.map(application => <ApplicationItem key={application?.id} application={application} />)}
      <Block marginTop="36px">
        <Button
          href={config.devConsoleUrl}
          iconPosition="right"
          icon={<Icon source={OpenInNew} />}
          kind="basic"
          target="_blank"
        >
          Go to Developers Console
        </Button>
      </Block>
    </Flex>
  );
};

export default PrivateApps;
